import React, { useState, useEffect } from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ItemsProvider } from './contexts/ItemsContext';
import { UserProvider } from './contexts/UserContext';
import NavBar from './components/NavBar';
import NewsTicker from './components/NewsTicker';
import Home from './pages/Home';
import Branding from './pages/Branding';
import Programs from './pages/Programs';
import ItemDetail from './pages/ItemDetail';
import ProfileCart from './pages/profile/Cart';
import ProfileFavorites from './pages/profile/Favorites';
import ProfileHistory from './pages/profile/History';
import ProfileCoupons from './pages/profile/Coupons';
import AdminRecommendations from './pages/profile/AdminRecommendations';
import AdminUsers from './pages/profile/AdminUsers';
import AdminPrograms from './pages/profile/AdminPrograms';
import AdminProgramDetail from './pages/profile/AdminProgramDetail';
import AdminFilters from './pages/profile/AdminFilters';
import AdminSettings from './pages/profile/AdminSettings';
import AdminReminders from './pages/profile/AdminReminders';
import ProfileNav from './components/ProfileNav';
import Confetti from './components/Confetti';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentFailure from './pages/PaymentFailure';
import { Navigate } from 'react-router-dom';
import Blog from './pages/Blog';
import ContactUs from './components/ContactUs';
import Minites from './pages/Minites';
import useScrollRestoration from './useScrollRestoration';
import Footer from './components/Footer';
import MoodPage from './pages/MoodPage';
import RecFloatingBadge from './components/RecFloatingBadge';
import AuthModal from './components/AuthModal';
import PopupOnce from './pages/PopupOnce';

function App() {
  const [showAuthModal, setShowAuthModal] = useState(false);

  useEffect(() => {
    const handler = () => setShowAuthModal(true);
    window.addEventListener('auth:logout', handler);
    return () => window.removeEventListener('auth:logout', handler);
  }, []);

  return (
    <UserProvider>
      <ItemsProvider>
        <Router>
        <div className="App">
          <NavBar />
          <NewsTicker />
          <main style={{ padding: 0 }}>
            {/** useScrollRestoration must be inside Router context */}
            {typeof window !== 'undefined' && <ScrollRestorationWrapper />}
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/branding" element={<Branding />} />
              <Route path="/programs" element={<Programs />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/item/:id" element={<ItemDetail />} />
              <Route path="/profile" element={<ProfileNav />}>
                <Route index element={<Navigate to="/profile/cart" replace />} />
                <Route path="cart" element={<ProfileCart />} />
                <Route path="favorites" element={<ProfileFavorites />} />
                <Route path="history" element={<ProfileHistory />} />
                <Route path="coupons" element={<ProfileCoupons />} />
                <Route path="admin-recommendations" element={<AdminRecommendations />} />
                <Route path="admin-users" element={<AdminUsers />} />
                <Route path="admin-programs" element={<AdminPrograms />} />
                <Route path="admin-programs/:id" element={<AdminProgramDetail />} />
                <Route path="admin-filters" element={<AdminFilters />} />
                <Route path="admin-site-settings" element={<AdminSettings />} />
                <Route path="admin-reminders" element={<AdminReminders />} />
              </Route>
              <Route path="/payment-success" element={<PaymentSuccess />} />
              <Route path="/payment-failure" element={<PaymentFailure />} />
              <Route path="/contactus" element={<ContactUs />} />
              <Route path="/minites" element={<Minites />} />
              <Route path="/mood" element={<MoodPage />} />
            </Routes>
          </main>
          <Footer />
          <RecFloatingBadge />
          <Confetti />
          {showAuthModal && <AuthModal onClose={() => setShowAuthModal(false)} />}
          <PopupOnce />
        </div>
        </Router>
      </ItemsProvider>
    </UserProvider>
  );
}

function ScrollRestorationWrapper() {
  // custom hook inside Router context
  useScrollRestoration();
  return null;
}

export default App;
